/**
 * 作品列表卡上的「官网」一行(1009 一期):未发 / 已排期·时间 / 已发布(链接)/ 发布失败。多站点取最要紧的一条
 * (失败 > 推送中 > 已排期 > 已发布 …),另几个站点记成「等 N 个站点」。租户还没有可发站点时不渲染(不给一个不可能的「未发」)。
 */
import { Globe } from "lucide-react";

import type { SitePublication } from "../api/reporterSiteService";
import { summarize } from "../model/sitePublication";
import { SiteStatusPill } from "./SitePublicationPanel";

export function SiteBadgeLine({
  items,
  hasSites,
}: {
  items: SitePublication[] | undefined;
  hasSites: boolean;
}) {
  const top = summarize(items ?? []);
  if (!top && !hasSites) return null;
  const others = (items?.length ?? 0) - 1;
  return (
    <div
      className="flex min-w-0 items-center gap-1 text-2xs text-muted-foreground"
      data-site-badge-line=""
    >
      <Globe className="h-3 w-3 shrink-0" />
      <span className="shrink-0">官网</span>
      {top ? (
        <>
          <SiteStatusPill p={top} />
          {top.status === "PUBLISHED" && top.siteUrl && (
            <a
              href={top.siteUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="truncate text-primary hover:underline"
              onClick={(e) => e.stopPropagation()}
            >
              查看
            </a>
          )}
          {others > 0 && <span className="shrink-0">等 {others + 1} 个站点</span>}
        </>
      ) : (
        <span data-site-status="NONE">未发</span>
      )}
    </div>
  );
}
